export const DeviceSize = {
    mobile: 669,
    tablet: 992,
    laptop: 1324,
    desktop: 1600,
  };